<% if (_.size(appointmentGridDates) > 0) { %>
  <% appointmentGridDates.forEach(function(gridDate, index) { %>
    <div class="appointment-slot-list gridDate" data-anchor="<%- gridDate.date %>">
      <h3 class="appointments-list-title grid-date-name"><%= moment(gridDate.date).format('dddd, MMMM D, YYYY') %></h3>
      <div class="appointments-list grid-dates">
        <%= JST['appointment_booking/slot_picker_modal/templates/list/slots']({slots: gridDate.slots, day: index + 1, renderLinks: renderLinks, testIds: testIds, I18n: I18n}) %>
      </div>
    </div>
  <% }) %>
  <div class="appointments-list-navigation js-show-more">
    <span class="appointments-list-navigation-control appointments-list-navigation-control--show-more" data-appointment-booking-slot-picker-modal-behaviour="show-more"
          data-analytics-element="slot-picker-list-show-more" data-analytics-interaction="click">
      <%= I18n.messages.show_more %>
    </span>
  </div>
<% } else { %>
  <div class="appointments-list-empty" data-analytics-element="slot-picker-no-results" data-analytics-interaction="shown" data-analytics-value="list">
    <div class="appointments-list-empty__header">
      <div class="appointments-list-empty__message"><%= I18n.messages.no_results %></div>
    </div>
  </div>
  <%= JST['appointment_booking/slot_picker_modal/templates/fallback_message']({schedulingOptions: schedulingOptions}) %>
<% } %>
